export default class BookletComments {
    constructor() {
        this.initCommentImageHandling();
        this.initImageZoom();
        // Ensure we only register handlers once
        if (!window.bookletCommentsInitialized) {
            this.bindEvents();
            window.bookletCommentsInitialized = true;
        }
    }
  
    bindEvents() {
      if($(".add-comment-btn").data("openImmediate") == true) {
        this.openCommentForm();
        this.validateCommentForm();
      }
    }

    openCommentForm() {
        $("#addCommentModal").modal("show");
    }

    validateCommentForm() {
        $("#add_comment_form").validate({
            rules: {
                "comment": {
                    required: true,
                    minlength: 1,
                }
            },
            messages: {
                "comment": {
                    required: "Veuillez saisir un commentaire",
                    minlength: "Veuillez saisir un commentaire"
                }
            },
            submitHandler: function(form) {
                form.submit();
            },
            errorClass: 'is-invalid',
            errorElement: 'div',
            errorPlacement: function(error, element) {
                error.addClass('invalid-feedback');
                error.insertAfter(element);
            }
        });
    }

    initCommentImageHandling() {
        // Import the ImageHandler utility
        import('../utils/ImageHandler').then(module => {
            const ImageHandler = module.default;
            // Create an instance of the image handler utility
            this.imageHandler = new ImageHandler();
            // Initialize all image handling functionality
            this.imageHandler.initializeImageHandling();
        });
    }

    initImageZoom() {
        // Import the ImageZoom utility
        import('../utils/ImageZoom').then(module => {
            const ImageZoom = module.default;
            // Create an instance of the image zoom utility
            this.imageZoom = new ImageZoom();
        });
    }
}